import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import styleConstants from "../../../styleConstants";

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
	paddingBottom: styleConstants.componentSpacing,
	[theme.breakpoints.down("xs") ]: {
		flexDirection: "column"
	}
  },
  figureRight: {
    width: "50%",
	order: 3,
	[theme.breakpoints.down("xs") ]: {
		width: "100%"
	}
  },
  figureLeft: {
    width: "50%",
	order: 1,
	[theme.breakpoints.down("xs") ]: {
		width: "100%"
	}
  },
  text: {
    width: "50%",
    padding: "0 2rem",
	order: 2,
	[theme.breakpoints.down("xs") ]: {
		width: "100%"
	}
  }
}));

const SmallFigure = props => {
  const classes = useStyles(props);

  return (
    <div className={classes.container}>
      <div className={classes.text}>{props.children}</div>
      {props.figureOnLeft ? (
        <div className={classes.figureLeft}>{props.figure}</div>
      ) : (
        <div className={classes.figureRight}>{props.figure}</div>
      )}
    </div>
  );
};

SmallFigure.propTypes = {
  figure: PropTypes.node.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  figureOnLeft: PropTypes.bool
};

SmallFigure.defaultProps = {
  figureOnLeft: false
};

export default SmallFigure;
